import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showAlert, closeAlert } from 'actions/common/alert';
import { fetchAddress } from 'actions/common/address';
import {
  postOrderAggregators,
  postOrderAggregatorsBankTransfer,
  getOrderAggregatorsError
} from 'actions/orderAggregators/confirmation';
import { push } from 'connected-react-router';
import Confirmation from 'components/OrderAggregators/Confirmation';

const mapStateToProps = ({ orderAggregatorsConfirmation }) => ({
  ...orderAggregatorsConfirmation
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchAddress,
      postOrderAggregators,
      postOrderAggregatorsBankTransfer,
      getOrderAggregatorsError,
      push,
      showAlert,
      closeAlert
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Confirmation);



// WEBPACK FOOTER //
// ./src/containers/OrderAggregators/Confirmation/index.js